import React from 'react';

const ArrowUp = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 12 7" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="ArrowUp_a" d="M839.3 811l1.36-1.32-5.83-5.68-5.83 5.68 1.36 1.32 4.47-4.35z" />
    </defs>
    <use fill="currentColor" xlinkHref="#ArrowUp_a" transform="translate(-829 -804)" />
  </svg>
);

export default ArrowUp;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowUp.js